import React from 'react';
import {
    Grid,
    Button,
    Typography,
    Box
} from '@mui/material';

const ModbusRow = React.memo(({
    item,
    index,
    handleEditInput,
    handleDeleteInput
}) => {

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={2}>
                <Box>
                    <Typography variant="caption">
                        Modbus Address
                    </Typography>
                    <Typography>
                        {item.RegAddr}
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={2.5}>
                <Box>
                    <Typography variant="caption">
                        English Text
                    </Typography>
                    <Typography>
                        {item.EnglishText}
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
                <Box>
                    <Typography variant="caption">
                        Address
                    </Typography>
                    <Typography>
                        {item.Addr}
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={2}>
                <Box>
                    <Typography variant="caption">
                        Data Type
                    </Typography>
                    <Typography>
                        {item.DataType}
                    </Typography>
                </Box>
            </Grid>

            <Grid item xs={12} sm={4} md={3.5}>
                <Grid container spacing={1}>
                    <Grid item>
                        <Button
                            variant="contained"
                            size="small"
                            color="secondary"
                            onClick={() => handleEditInput(index, item)}
                        >
                            Edit
                        </Button>
                    </Grid>

                    <Grid item>
                        <Button
                            variant="contained"
                            size="small"
                            color="error"
                            onClick={() => handleDeleteInput(index)}
                        >
                            Delete
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
});

const ModbusForm = ({
    fields,
    handleEditInput,
    handleDeleteInput
}) => {

    return (
        <>
            {fields.map((item, index) => (
                <ModbusRow
                    key={item.RegAddr}
                    item={item}
                    index={index}
                    handleEditInput={handleEditInput}
                    handleDeleteInput={handleDeleteInput}
                />
            ))}
        </>
    );
};

export default React.memo(ModbusForm);